module.exports = __webpack_public_path__ + "img/gallery.15c43541.svg";